import clayPic from "@/public/images/artists/clay.jpg";
import { Artist } from "@/types/types";

export const clay = {
  id: "250",
  name: "Clay",
  image: clayPic,
  description: `Clay's voice is low and weathered with a measured delivery — like someone who's seen a lot but doesn't need to say much.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fclay-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Spoken Word"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 42,
        high: 51,
      },
      sweetSpot: 46,
    },
  },
} as const satisfies Artist;
